import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('CopyTaskTemplateDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'template',
    copyTaskTemplateDialogCtrl,
  ]);

function copyTaskTemplateDialogCtrl($element, $scope, $http, appUrls, flySvc, close, template) {
  var vm = this;
  vm.showValidation = false;
  vm.translation = {};
  vm.name = template.name;
  vm.template = angular.extend({}, template);

  vm.updateName = function(value) {
    vm.name = value;
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    if (vm.translation && !vm.translation.isValid(true)) return;
    vm.saving = true;
    $http
      .post(`${appUrls.tasks}/api/tasktemplates/copy/${vm.template.id}`, null, {
        params: { name: vm.name },
      })
      .then(
        function({ data = {} }) {
          vm.saving = false;
          if (data && data.id && vm.translation && vm.translation.save) {
            return vm.translation.save(data.id).then(function() {
              $element.modal('hide');
              close(data, 500);
              flySvc.success('msgTaskTemplateCopied');
              return false;
            });
          } else {
            $element.modal('hide');
            close(data, 500);
            flySvc.success('msgTaskTemplateCopied');
            return false;
          }
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error);
        },
      );
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
